<template>
<div>
	  <div class="container-rows wrap">
		<div class="product-row">
			<img :src="getUrlImage" alt="" class="product-image">
			<div class="content-product">
				<p class="product-name">{{getProductName}}</p>
				<p class="product-description">{{item.description}}</p>
				<p class="product-code">#{{getProductCode}}</p>
			</div>
		</div>
	</div>
</div>
</template>
<script>

function getProductCode() {
	return this.item.code || this.item.productCode;
}

function getProductName() {
	return this.item.name || this.item.productName;
}

function getUrlImage() {
	return this.item.imgPresentation || this.item.urlImage || this.item.productImage;
}

export default {
	name: 'rows-table',
	computed: {
		getProductCode,
		getProductName,
		getUrlImage,
	},
	props: {
		item: {
			default: () => {},
			type: Object,
		},
		imageNone: {
			default: true,
			type: Boolean,
		},
	},
};
</script>


<style lang="scss" scoped>
.product-row {
	align-items: flex-start;
	display: grid;
	grid-column-gap: 1rem;
	grid-template-columns: minmax(5.5rem, 15rem) minmax(13rem, 26rem);
	grid-template-rows: 15rem;
}
.text-code {
	color: color(textCode);
}

.container-rows {
	background-color: color(white);
	padding: 2.9rem 0;

	@media screen and (max-width: 425px) {
		max-width: 18rem;
	}
}

.content-product {
	text-align: left;

	p {
		margin: 0;
	}

	@media (max-width: 425px) {
		font-size: size(tiny);
		max-width: 15rem;
		text-align: center;
	}
}

.text-description {
	font-family: font(open-regular);
	max-width: 27rem;
}

.bar-table {
	height: 2rem;
}

.product-image {
    height: auto;
	object-fit: contain;
	width: 100%;
}

.product-name {
	color: color(textCode);
	font-family: font(avenirBold);
	margin-bottom: 0.3rem !important;
}

.product-description,
.product-code {
	color: color(textCode);
	font-family: font(avenir);
	font-size: size(medium);
}

.product-description {
	margin-bottom: 1.5rem !important;
}
</style>



// WEBPACK FOOTER //
// rowsTable.vue?0aa56432